module.exports = __webpack_public_path__ + "img/banner-5.84f62d8c.jpg";